import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                'select': 'changeLanguage'
            }
        }

        this.select = this.$('select')[0]
    }

    changeLanguage() {
        for(let classToRemove of ["has-header-nav-opened","has-menu-opened","is-loaded","is-ready"])
            html.classList.remove(classToRemove)

        html.classList.add('is-loading');

        window.location.href = this.getData('url', this.select.options[this.select.selectedIndex])
    }
}
